/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/coordinator/coordinator.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from "@angular/core";
import { VisionIcsApiService } from "vics/visionics/api/ng/index";
import * as i0 from "@angular/core";
import * as i1 from "vics/visionics/api/ng/index";
export class CoordinatorListResolver {
    /**
     * @param {?} api
     */
    constructor(api) {
        this.api = api;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        // route.paramMap.get('id')
        return this.api.listCoordinator();
    }
}
CoordinatorListResolver.decorators = [
    { type: Injectable, args: [{ providedIn: "root" },] },
];
/** @nocollapse */
CoordinatorListResolver.ctorParameters = () => [
    { type: VisionIcsApiService }
];
/** @nocollapse */ CoordinatorListResolver.ɵfac = function CoordinatorListResolver_Factory(t) { return new (t || CoordinatorListResolver)(i0.ɵɵinject(i1.VisionIcsApiService)); };
/** @nocollapse */ CoordinatorListResolver.ɵprov = i0.ɵɵdefineInjectable({ token: CoordinatorListResolver, factory: CoordinatorListResolver.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CoordinatorListResolver, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.VisionIcsApiService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    CoordinatorListResolver.prototype.api;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29vcmRpbmF0b3IucmVzb2x2ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9jb29yZGluYXRvci9jb29yZGluYXRvci5yZXNvbHZlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLE9BQU8sRUFBQyxVQUFVLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFPekMsT0FBTyxFQUVMLG1CQUFtQixFQUNwQixNQUFNLDZCQUE2QixDQUFDOzs7QUFHckMsTUFBTSxPQUFPLHVCQUF1Qjs7OztJQUNsQyxZQUNxQixHQUF3QjtRQUF4QixRQUFHLEdBQUgsR0FBRyxDQUFxQjtJQUMxQyxDQUFDOzs7Ozs7SUFFSixPQUFPLENBQUMsS0FBNkIsRUFDN0IsS0FBMEI7UUFDaEMsMkJBQTJCO1FBQzNCLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxlQUFlLEVBQUUsQ0FBQztJQUNwQyxDQUFDOzs7WUFWRixVQUFVLFNBQUMsRUFBQyxVQUFVLEVBQUcsTUFBTSxFQUFDOzs7O1lBSC9CLG1CQUFtQjs7OEZBSVIsdUJBQXVCOytEQUF2Qix1QkFBdUIsV0FBdkIsdUJBQXVCLG1CQURWLE1BQU07a0RBQ25CLHVCQUF1QjtjQURuQyxVQUFVO2VBQUMsRUFBQyxVQUFVLEVBQUcsTUFBTSxFQUFDOzs7Ozs7O0lBRzNCLHNDQUF5QyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7SW5qZWN0YWJsZX0gZnJvbSBcIkBhbmd1bGFyL2NvcmVcIjtcbmltcG9ydCB7XG4gIEFjdGl2YXRlZFJvdXRlU25hcHNob3QsXG4gIFJlc29sdmUsXG4gIFJvdXRlclN0YXRlU25hcHNob3QsXG59IGZyb20gXCJAYW5ndWxhci9yb3V0ZXJcIjtcbmltcG9ydCB7T2JzZXJ2YWJsZX0gZnJvbSBcInJ4anNcIjtcbmltcG9ydCB7XG4gIEFwaUNvb3JkaW5hdG9yTGlzdFBiLFxuICBWaXNpb25JY3NBcGlTZXJ2aWNlXG59IGZyb20gXCJ2aWNzL3Zpc2lvbmljcy9hcGkvbmcvaW5kZXhcIjtcblxuQEluamVjdGFibGUoe3Byb3ZpZGVkSW4gOiBcInJvb3RcIn0pXG5leHBvcnQgY2xhc3MgQ29vcmRpbmF0b3JMaXN0UmVzb2x2ZXIgaW1wbGVtZW50cyBSZXNvbHZlPEFwaUNvb3JkaW5hdG9yTGlzdFBiPiB7XG4gIGNvbnN0cnVjdG9yKFxuICAgICAgcHJpdmF0ZSByZWFkb25seSBhcGk6IFZpc2lvbkljc0FwaVNlcnZpY2UsXG4gICkge31cblxuICByZXNvbHZlKHJvdXRlOiBBY3RpdmF0ZWRSb3V0ZVNuYXBzaG90LFxuICAgICAgICAgIHN0YXRlOiBSb3V0ZXJTdGF0ZVNuYXBzaG90KTogT2JzZXJ2YWJsZTxBcGlDb29yZGluYXRvckxpc3RQYj4ge1xuICAgIC8vIHJvdXRlLnBhcmFtTWFwLmdldCgnaWQnKVxuICAgIHJldHVybiB0aGlzLmFwaS5saXN0Q29vcmRpbmF0b3IoKTtcbiAgfVxufVxuIl19